// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;
(function(){

	$(document).ready(function () {
	
		//booking Calendar
		$('.js-close-menu').click(function (event) {
			$('.menu-content').removeClass('show');
		});

		$('.js-open-booking').click(function (event) {
			$('#bookingWidget').addClass('show');
		});

		$('.booking-widget__close').click(function (event) {
			$('#bookingWidget').removeClass('show');
		});


		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}
		
		(function(){
			let allAccordionItems = document.getElementsByClassName('js-accordion-title');
			let allALength = allAccordionItems.length;
	
			for(let i =0; i < allALength; i++){
				allAccordionItems[i].addEventListener('click', function(){
					let currentParent = this.parentElement;
					let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
					let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0]
					if(currentParent.classList.contains('open')){
						currentParent.classList.remove('open');
						currentCopy.style.height = '0';
					} else {
						currentParent.classList.add('open');
						currentCopy.style.height = currentCopyHeight + 'px';
					}
				})
			}
	
		}())

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null)); // trigger custom callback
		}
		$('#arriveInput').on('change', function () {
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		});
		$('#departureInput').on('change', function () {
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		});
		//alert($('#arriveInput').val());

		$('.calendar-block').datepicker({
			changeMonth: true,
			dateFormat: 'yy-mm-dd',
			numberOfMonths: 1,
			//altField: "#arriveInput",
			//altFormat: "mm-dd-yy",
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "yy-mm-dd";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				//console.log(opened);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}

					console.log(start)
					console.log(end)

					setTimeout(function(){
						$("#calendar_home").hide();
						$("#check_in_out").attr('value', start + '/' + end);

						var hoemBookingDates = $('#check_in_out').attr('value').split('/');
						$('#booking-home #arriveInput').attr('value', hoemBookingDates[0]);
						$('#booking-home #departureInput').attr('value', hoemBookingDates[1]);
					}, 500)

				}
				//console.log(start);
				//console.log(end);

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				$('#arriveInput').val(start);
				$('#departureInput').val(end);

			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});

		$("#calendar_home").hide();
		$( "#check_in_out" ).on( "click", function(){ $("#calendar_home").show(); } )

		/* Up/Down added to guests number on booking widget*/
		let adultsNumber = document.querySelector('#adults'),
		adultsPlus = document.querySelector('.adults-plus'),
		adultsMinus = document.querySelector('.adults-minus');


		setTimeout(() => {
			$(".booking-widget #ui-datepicker-div").detach().appendTo('.js-booking-target');
		}, 1000);

		let adultsNumberValue = adultsNumber.getAttribute('value');
		adultsPlus.addEventListener('click', () => {
			if (adultsNumberValue < 6) {
				adultsNumberValue++;
				adultsNumber.setAttribute('value', adultsNumberValue);
			}
		});
		adultsMinus.addEventListener('click', () => {
			if (adultsNumberValue > 1) {
				adultsNumberValue--;
				adultsNumber.setAttribute('value', adultsNumberValue);
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		$('.ui-datepicker-title').prepend('<label for="select_month_calendar_booking" class="hidden">Select month</label>');
		$('.ui-datepicker-month').attr('name', 'select_month_calendar_booking');
		$('.ui-datepicker-month').attr('id', 'select_month_calendar_booking');


		//Header Home
		$('.slider-home-nav__item').mouseover(function () {
			$('.slider-home').slick('slickGoTo',$(this).index());
		});
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

/* Navigation menu */
var navbutton = document.querySelectorAll('.header__hamburger');
navbutton.forEach( (t) => {
	t.addEventListener('click', function(e){
		e.preventDefault();
		var deheader = document.querySelector('#header');
		deheader.classList.toggle('open-nav');
		document.querySelector('nav.buttons').classList.toggle('open-nav');
		console.log(deheader.classList.contains('open-nav'));
		if( deheader.classList.contains('open-nav') ){
			document.querySelector('.header__hamburger .button__btn__label').innerHTML = 'Close';
		}else{
			document.querySelector('.header__hamburger .button__btn__label').innerHTML = 'Menu';
		}
	}); 
});

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	
	//check scroll down or up for header styles
	let ts = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('top-content').classList.contains('down')){
				document.getElementById('top-content').classList.add('down');
				document.getElementById('top-content').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('top-content').classList.contains('up')){
				document.getElementById('top-content').classList.add('up');
				document.getElementById('top-content').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('top-content').classList.contains('up') || document.getElementById('top-content').classList.contains('down')){
			document.getElementById('top-content').classList.remove('up');
			document.getElementById('top-content').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/*****************************************************
OBSERVER TO ADD PARALLAX EFFECT
/*****************************************************/
	var scrollParallax = [];
	var scrolled = 0;
	
	// screen height
	var v_height =
	window.innerHeight ||
	document.documentElement.clientHeight ||
	document.body.clientHeight;
	
	function doParallax(elm) {
	let boundes = elm.dataset.parallax.split(","); // get it from html
	//get distance in positive value
	let distance = Math.abs(boundes[0] - boundes[1]);
	if (boundes[0] > boundes[1]) {
		//get distance in negative value (to do the scroll inverse)
		distance = distance * -1;
	}
	//Equivalent distance using screen height + element height
	const unit_scroll = distance / (v_height + elm.offsetHeight);
	let temp = 0;
	
	let topElement = 0;
	let element = elm;
	
	let id_elem = elm.dataset.parallaxid;
	
	do {
		topElement += element.offsetTop || 0;
		element = element.offsetParent;
	} while (element);
	
	let parallaxFunction = function () {
		//Obtain the distance between top screen and document top 0
		scrolled = document.documentElement.scrollTop || window.pageYOffset;
		//Distance of bottom page to top of the element
		let relative_distance = scrolled + v_height - topElement;
		//transpoling data to move the parallax element relative to the scroll of all the screen
		temp = unit_scroll * relative_distance + parseInt(boundes[0]);
		//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
		elm.setAttribute("style", "transform: translate(0, " + temp + "px)");
	};
	
	scrollParallax[id_elem] = parallaxFunction;
	
	window.addEventListener("scroll", scrollParallax[id_elem]);
	}
	
	let observers_parallax = document.querySelectorAll(".js-parallax-element");
	
	if (observers_parallax) {
	let options_parallax = {
		root: null, // relative to document viewport
		rootMargin: "0px", // margin around root. Values are similar to css property. Unitless values not allowed
		threshold: 0, // visible amount of item shown in relation to root
	};
	
	function handler_parallax(entries, observer) {
		let entry;
		entries.forEach(function (entry) {
		if (entry.isIntersecting) {
			doParallax(entry.target);
		} else {
			let id_elem = entry.target.dataset.parallaxid;
			window.removeEventListener("scroll", scrollParallax[id_elem]);
		}
		});
	}
	
	let observable_parallax = new IntersectionObserver(
		handler_parallax,
		options_parallax
	);
	let counter = 1;
	observers_parallax.forEach(function (element) {
		observable_parallax.observe(element);
		element.dataset.parallaxid = counter;
		counter++;
	});
	}

	//for Menus
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
			btn.addEventListener('click', () => {
				console.log(`Pestaña clickeada: ${btn.dataset.tag}`);
				document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active'); 
				document.querySelectorAll('.menu__unitmenu').forEach(room => {
					room.classList.remove('active');
					if (btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag) {
						room.classList.add('active'); 
					}
				});
			});
			if (i === 0) btn.click();
		});
		const url_tag = window.location.hash ? window.location.hash.replace('#', '') : null;
		const li_match = document.querySelector(`.menu-restaurant__tabs li[data-tag="${url_tag}"]`);
		if (url_tag && li_match) {
		li_match.click();
		setTimeout(() => {
				const menu_scroll = document.querySelector(`.menu-restaurant__tabs li[data-tag="${url_tag}"]`); // Ajusta el selector del contenido
				if (menu_scroll) {
					menu_scroll.scrollIntoView({ 
						behavior: 'smooth',
						block: "center"
					});
				}
			}, 500); 
		}
	});

document.getElementById("close-menu-js").addEventListener("click", function () {
	let nav = document.getElementById("header");
	let toggle = document.getElementById("header");
	this.classList.remove("open-nav");
	this.parentElement.classList.remove("open-nav");
	nav.classList.remove("open-nav");
	toggle.classList.remove("open-nav");
});